<template>
  <div>
    <my-upload
      langType="en"
      field="img"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="300"
      :height="300"
      :params="params"
      :headers="headers"
      img-format="png"
      :noSquare="true"
    >
    </my-upload>
    <div class="profile-card">
      <div
        class="profile-bg"
        :style="{ 'background-image': 'url(' + img + ')' }"
      ></div>
      <img
        @mouseenter="showPrompt = true"
        v-if="imgDataUrl || profile.imgURL"
        :src="imgDataUrl ? imgDataUrl : profile.imgURL ? profile.imgURL : ``"
        class="avatar"
        :alt="profile.firstname"
      />
      <div
        v-if="!imgDataUrl && !profile.imgURL"
        @mouseenter="showPrompt = true"
      >
        <b-avatar
          class="avatar"
          :text="getInitials(profile.firstname, profile.lastname)"
        />
      </div>
      <div
        @mouseleave="showPrompt = false"
        v-if="showPrompt"
        class="update-profile-btn"
        @click="toggleShow"
      >
        <div class="fa fa-camera camera-icon"></div>
      </div>
      <div class="profile-details">
        <h2>{{ `${profile.firstname} ${profile.lastname}` }}</h2>
        <p>
          {{ profile.mainline }}
        </p>
        <h6>
          Connected Since
          {{ new Date(profile._created_at.toDate()).getFullYear() }}
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyUpload from "vue-image-crop-upload";
import firebase from "firebase";
export default {
  data() {
    return {
      img: require("@/assets/svg/bgcc.svg"),
      show: false,
      showPrompt: false,
      imgDataUrl: "",
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      }
    };
  },
  components: {
    MyUpload
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    })
  },
  methods: {
    getInitials(fname, lname) {
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    shefPercentage(sphere) {
      return this.profile.shef[sphere];
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      this.updateProfileImage(imgDataUrl);
    },
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    updateProfileImage(imgDataUrl) {
      console.log(imgDataUrl, "ini di popipipipip");
      //Upload to server --
      //TODO:Move to store?
      var storageRef = firebase
        .storage()
        .ref(`profile_img/${this.$store.state.user.user.uid}`);

      var metadata = {
        contentType: "image/jpeg"
      };
      var uploadTask = storageRef.putString(imgDataUrl, "data_url");

      uploadTask.on(
        "state_changed",
        snapshot => {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        error => {
          console.log("Error uploading image: ", error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$store
              .dispatch("user/updateProfile", { imgURL: downloadURL })
              .then(() => {
                this.$store.dispatch("user/getProfile").then(() => {
                  console.log("successfully saved at", downloadURL);
                });
              });
          });
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-card {
  max-width: 294px;
  width: 100%;
  //   height: 357px;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  border-radius: 8px !important;
  background: #ffffff;
  position: relative;
  font-family: "Nunito", sans-serif;
  @media (max-width: 767px) {
    margin-left: auto;
    margin-right: auto;
  }
  .profile-bg {
    max-width: 294px;
    width: 100%;
    height: 114px;
    background: rgba(184, 136, 92, 0.1);
    background-color: #ddbc9e;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    background-repeat: repeat-x;
  }
  .avatar {
    border-radius: 50%;
    width: 112px;
    height: 112px;
    object-fit: cover;
    // transform: translateY(-60px);
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    margin-top: -61px;
  }
  .profile-details {
    margin-top: 12px;
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;

      text-align: center;

      color: #474d52;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;

      color: #474d52;
      padding: 0 24px;
      margin-top: 19px;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #a1b1ba;
      padding-top: 16px;
      padding-left: 24px;
      padding-bottom: 24px;
    }
  }
  .update-profile-btn {
    position: absolute;
    left: 24%;
    top: 42%;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.7);
    color: #272f75;
    font-weight: bold;
    cursor: pointer;
    height: 55px;
    width: 135px;
    font-size: 12px;
  }
  .camera-icon {
    margin-top: 8px;
    font-size: 20px;
  }
}
</style>
